import { IParameterService } from './ParameterService.types';
import { ISelectOptions } from 'react-ocean-forms-bootstrap';
import { StatusApi } from './StatusApi';
import { ParameterCreateDto, ParameterReleasesDto, ParameterDuplicates } from './dto';
import { ParameterFormValues } from '../components/Parameter';
import { ParameterServiceApi } from './services';
import { ServiceUtil, handleServiceError } from './ServiceUtil';
import { MethodQuery, OtherCriterionQuery, MatrixQuery, DimensionQuery, MaterialQuery, UnitQuery, SamplePretreatmentQuery, NonMaterialQuery } from '../graphql/Components';
import { ServiceError } from './errors';
import { ParameterStatusUtil } from './ParameterStatusUtil';
import { Alternativname, Matrix, Maybe, Methode, Parameter, ParameterStatus, SonstigesKriterium } from '../generated/types';

class ParameterServiceImpl implements IParameterService {
  
  async createParameter(values: ParameterFormValues): Promise<any> {

    const dto: ParameterCreateDto = this.transformFormToDto(values);
    console.log('form dto', values, dto);
    const result = await ParameterServiceApi.createParameter(dto, handleServiceError);
    console.log('result api', result);
    return result;
  }

  async editParameter(id: number, values: ParameterFormValues): Promise<any> {
    const dto: ParameterCreateDto = this.transformFormToDto(values);
    const response = await ParameterServiceApi.editParameter(id, dto, handleServiceError);
    console.log('parameter-edit', response);
    if (response?.status === 200 || response?.status === 201) {
      return response.data;
    }
    throw new ServiceError(500, {message: 'Unbekannter Fehler', status: 500});
  }

  async releaseParameters(releases: ParameterReleasesDto): Promise<ParameterReleasesDto> {

    const result = await ParameterServiceApi.releaseParameters(releases, handleServiceError);
    console.log('parameter-released ', releases, result);
    if(result) {
      return result?.data;
    }
    throw new ServiceError(500, {message: 'Unbekannter Fehler', status: 500});
  }

  async denyParameter(id: number, anmerkung: string): Promise<void> {
    const dto = { anmerkung };
    const response = await ParameterServiceApi.denyParameter(id, dto, handleServiceError);
    console.log('parameter-deny', response);
    if (response?.status === 200 || response?.status === 204) {
      return;
    }
    throw new ServiceError(500, {message: 'Unbekannter Fehler', status: 500});
  }

  async checkDuplicates(values: ParameterFormValues, id: number | undefined): Promise<ParameterDuplicates> {
    const dto = this.transformFormToDto(values);
    // @ts-ignore EINPAR-450 add id for edit duplicates
    if(id) dto.id = id;
    console.log('check duplicates', values, dto);
    const result = await ParameterServiceApi.checkParameterDuplikate(dto, handleServiceError);
    if (result) {
      return result.data;
    }
    throw new ServiceError(500, {message: 'Unbekannter Fehler', status: 500});
  }

  async getParameterStatus(): Promise<ISelectOptions> {

    const result = await StatusApi.getParameterStatus();

    console.log(result);
    const options: ISelectOptions = [];
    if (result && result.data) {
      result.data._embedded.content.forEach( e => {
        options.push({ label: e.name, value: e.id});
      });
    }
    return options;
  }

  transformDataToForm(values: Parameter): ParameterFormValues | {} {
    
    // fix rendering issues
    if (values === null) return {};

    const status = values.status;
    const statusOption = ParameterStatusUtil.getStatusOption(ParameterStatusUtil.getStatus(status || ParameterStatus.Ps1));
    const result = {
      id: values.id,
      name: values?.name ?? '',
      code: values.code ?? '',
      alternativnamen: values.alternativnamen?.flatMap((e: Maybe<Alternativname>) => e ? {label: e.name, value: e.name} :  []),
      anforderung: {
        email: values.anforderung?.email,
        zweckOderQuelle: values.anforderung?.zweckOderQuelle,
        anmerkung: values.anforderung?.anmerkung,
      },
      
      dimension: values?.einheit?.dimension ? DimensionQuery.getSelectOption(values.einheit.dimension) : undefined,
      material: values.stoff ? MaterialQuery.getSelectOption(values.stoff) : undefined,
      unit: values.einheit ? UnitQuery.getSelectOption(values.einheit) : undefined,
      sample_pretreatment: values.probenvorbehandlung ? SamplePretreatmentQuery.getSelectOption(values.probenvorbehandlung) : undefined,
      non_material: values.nichtstofflich ? NonMaterialQuery.getSelectOption(values.nichtstofflich) : undefined,
      
      /**
       * for optional components set value as a fixed value for status PS2*
       */
      method: values?.methoden?.flatMap((e: Maybe<Methode>) => e ? MethodQuery.getSelectOption(e, (status === ParameterStatus.Ps2A ||  status === ParameterStatus.Ps2B)) : []),
      other_criterion: values?.sonstigeKriterien?.flatMap((e: Maybe<SonstigesKriterium>) => e ? OtherCriterionQuery.getSelectOption(e, (status === ParameterStatus.Ps2A ||  status === ParameterStatus.Ps2B)) : []),
      matrix: values?.matrizen?.flatMap((e: Maybe<Matrix>) => e ? MatrixQuery.getSelectOption(e, (status === ParameterStatus.Ps2A ||  status === ParameterStatus.Ps2B)) : []),

      status: statusOption
    }

    return result;
  }

  transformFormToDto(values: ParameterFormValues ): ParameterCreateDto {
    console.log('form-to-dto', values);
    const dto: ParameterCreateDto = {
      name: values.name,
      alternativnamen: ServiceUtil.transformSelectOptionsToStringList(values.alternativnamen),
      status: values.status.value ? values.status.value : 'PS1',
      einheit: ServiceUtil.transformSelectJsonToKompId(values.unit),
      probenvorbehandlung: ServiceUtil.transformSelectJsonToKompId(values.sample_pretreatment),
      stoff: values.material ? ServiceUtil.transformSelectJsonToKompId(values.material) : undefined,
      nichtstofflich: values.non_material ? ServiceUtil.transformSelectJsonToKompId(values.non_material) : undefined,
      sonstigeKriterien: ServiceUtil.transformSelectJsonsToKompIdList(values.other_criterion),
      methoden: ServiceUtil.transformSelectJsonsToKompIdList(values.method),
      matrizen: ServiceUtil.transformSelectJsonsToKompIdList(values.matrix),
      anforderung: values.anforderung,
    };

    return dto;
  }
}

export const ParameterService = new ParameterServiceImpl();
